export const SIGNUP_FORM_DEFAULT_VALUES = {
  email: '',
  password: '',
  lastName: '',
  firstName: '',
  contactOk: false,
  token: '',
}

export const MAYBE_LOCAL_AUTHORITY_APE_CODE = ['8411Z']
